import { useEffect } from 'react';

import type { Table } from './useTable/types.js';

/**
 * Updates the page index to the last non-empty page when the current page is empty.
 * Necessary for paginated tables with sub-rows.
 * @internal
 */
export function usePaginationEmptyPageCorrection<TData>(
  table: Table<TData>,
): void {
  const currentPageRowCount = table.getPaginationRowModel().rows.length;

  useEffect(() => {
    const { enablePagination, controlledPageIndex } = table.options;

    if (enablePagination === false || controlledPageIndex === true) {
      return;
    }

    const { pageIndex, pageSize } = table.getState().pagination;

    // If there are no rows to display on the current page, navigate to the last non-empty page
    if (pageIndex > 0 && currentPageRowCount === 0) {
      const totalRowCount = table.getCoreRowModel().rows.length;
      const firstNonEmptyPrevPage = Math.ceil(totalRowCount / pageSize) - 1;
      table.setPageIndex(firstNonEmptyPrevPage, 'internal');
    }
  }, [table, currentPageRowCount]);
}
